<template>
  <section>
    <div class="form-content">
      <el-form-item label="退库时间">
        <el-date-picker v-model="form.time" style="width:250px!important;" value-format="yyyy-MM-dd HH:mm:ss"
          size="mini" type="datetime" placeholder="选择日期时间">
        </el-date-picker>
      </el-form-item>

      <el-form-item label="物品明细">
        <section class="consumable-list">
          <div class="list-title">
            <div class="r">
              <el-button @click="AddMaterial()" type="primary" size="mini">添加物品</el-button>
            </div>
          </div>
          <div class="consumable-table">
            <el-table :data="form.consumableItems" border>
              <el-table-column prop="consumable.consumable.number" label="物品编号">
              </el-table-column>
              <el-table-column prop="consumable.consumable.name" width="260" label="明细名称">
              </el-table-column>
              <el-table-column prop="consumable.consumable.unit.name" align="center" label="计量单位">
              </el-table-column>
              <el-table-column prop="amount" align="center" label="数量">
              </el-table-column>
              <el-table-column prop="backNum" align="center" label="可退库">
              </el-table-column>

              <el-table-column label="操作" width="80">
                <template slot-scope="scope">
                  <el-tooltip class="item" effect="dark" content="点击变更信息" placement="bottom">
                    <i @click="MaterialChange(scope.row, scope.$index)"
                      class="iconfont icon-xiugai meeting-btn-icon  mbi-edit"></i>
                  </el-tooltip>
                  <el-tooltip class="item" effect="dark" content="点击删除" placement="bottom">
                    <i @click="MaterialDelete(scope.$index)"
                      class="iconfont icon-close meeting-btn-icon mbi-remove"></i>
                  </el-tooltip>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </section>
      </el-form-item>
    </div>
    <!-- 添加物品 -->
    <div class="pop-room" v-if="addStatus">
      <a href="javascript:;" @click="addStatus=false" class="iconfont icon-close"></a>
      <div class="pop-cont">
        <el-col :span="22">
          <el-form ref="form" :model="mform" label-width="120px" class="form">
            <el-form-item label="物品编号" v-if="mform.consumable">
              <el-input :disabled="true" size="small" v-model="mform.consumable.consumable.number"></el-input>
            </el-form-item>
            <el-form-item label="*明细名称">
              <el-select size="small" style="width:100%" filterable v-model="mform.consumableId" @change="handleSelect"
                placeholder="支持搜索">
                <!-- <el-option v-for="item in consumableList" :key="item.id"
                  :label="item.name+' ('+item.dl.name+') ('+item.spec+')'" :value="item.id">
                </el-option> -->


                <el-option v-for="item in consumableList" :key="item.id"
                  :label="item.name+' ('+item.dl.name+')'+(item.spec?' 【'+item.spec+'】':'')" :value="item.id">
                </el-option>

              </el-select>
            </el-form-item>

            <el-form-item label="*数量">
              <el-input size="small" type="number" v-model="mform.amount"></el-input>
            </el-form-item>

            <el-form-item label="可退库" v-if="mform.backNum || mform.backNum=='0'">
              <el-input :disabled="true" size="small" v-model="mform.backNum"></el-input>
            </el-form-item>
            <el-form-item label="计量单位" v-if="mform.consumable">
              <el-select @change="forceUpdate" :disabled="true" size="small" filterable v-model="mform.consumable.consumable.unit.id"
                placeholder="请选择计量单位">
                <el-option v-for="item in unitList" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="">
              <el-button @click="AddBtnClick()" class="form-btn" type="success">确认提交</el-button>
            </el-form-item>
          </el-form>
        </el-col>
      </div>
    </div>
  </section>

</template>
<script>
  export default {
    props: ['formByFather', 'userData', 'isBack'],
    data() {
      return {
        form: {},

        // 选择项目列表
        supplierList: '',
        unitList: '',
        customerList: '',

        addType: 0,
        editIndex: '',
        mform: {
          consumable: '',
          consumableId: '',
          amount: '',
          backNum: '',
        },

        depId: '',
        addStatus: false,

      }
    },
    created() {},
    mounted() {
      this.form = this.formByFather

      this.form.depId = this.userData.secDepIds.split(",")[0] / 1
      this.form.customerId = this.userData.id

      // this.getHouseList()
      // this.getSupplierList()
      this.getUnitList()
      this.getMaterialList()
      this.getCustomerList()
    },
    methods: {
      // select刷新view
      forceUpdate(item) {
        this.$forceUpdate()
      },
      // 获取客户名单
      getCustomerList() {
        ajax.get('/consumable/valid/customers', {
          depId: this.form.depId
        }, (res) => {
          this.customerList = res.vo.data
        })
      },
      // 查询物品可退库数量
      handleSelect(consumableId) {
        // 查询物品资料
        ajax.post('/consumable/queryBy/id', {
          id: consumableId,
          depId: this.form.depId,
        }, (res) => {
          this.$set(this.mform, 'consumable', res.vo)
        })
        // 查询可退库数量
        ajax.get('/consumable/back/num', {
          consumableId: consumableId,
          depId: this.form.depId,
          customerId: this.form.customerId,
        }, (res) => {
          this.$set(this.mform, 'backNum', res.vo.data)
        })
      },
      // 编辑物品
      MaterialChange(row, index) {
        this.addType = 1
        this.editIndex = index
        this.mform = row
        this.addStatus = true
      },
      // 从列表里删除当前物品
      MaterialDelete(index) {
        // console.log(index)
        this.form.consumableItems.splice(index, 1)
      },
      // 显示添加物品弹窗
      AddMaterial() {
        this.mform = {
          consumable: '',
          consumableId: '',
          amount: '',
        }
        this.addType = 0
        this.addStatus = true
      },
      // 添加物品到列表
      AddBtnClick() {
        if (!this.mform.consumableId || !this.mform.amount) {
          this.$message.error("请认真填写物品信息，带*为必填项")
          return
        }
        if (this.mform.amount > parseFloat(this.mform.backNum)) {
          this.$message.error("数据错误：退库数量大于可退库数量，请仔细检查是否输入错误")
          return
        }

        // this.mform.totalPrice = (this.mform.price * this.mform.amount).toFixed(2)
        this.mform.unitName = this.getUnitName(this.mform.unitId)
        if (this.addType == 0) {
          this.form.consumableItems.push(this.mform)
        } else {
          this.form.consumableItems.splice(this.editIndex, 1, this.mform)
        }

        // 初始化
        this.mform = {
          consumable: '',
          consumableId: '',
          amount: '',
        }
        this.addStatus = false
      },
      // 获得计量单位名称
      getUnitName(unitId) {
        for (var i = 0; i < this.unitList.length; i++) {
          let _item = this.unitList[i]
          if (unitId == _item.id) {
            return _item.name
          }
        }
      },
      // 获取物品基础资料列表
      getMaterialList() {
        ajax.get('/consumable/list', {
          // 'depId': 2
        }, (res) => {
          this.loading = false
          this.consumableList = res.vo.array
        })
      },
      // 获取供应商列表
      getSupplierList() {
        ajax.get('/supplier/list', {
          'type': 2
        }, (res) => {
          this.supplierList = res.vo.array
        })
      },
      // 获取计量单位列表
      getUnitList() {
        ajax.get('/storage/unit/list', '', (res) => {
          this.unitList = res.vo.array
        })
      },
      // 返回form
      getFromData() {
        return this.form
      }
    },
    watch: {
      formByFather() {
        this.form = this.formByFather
      },
      // 'form.consumables': {
      //   handler(newName, oldName) {
      //     let _total = 0
      //     for (let i = 0; i < this.form.consumables.length; i++) {
      //       let _item = this.form.consumables[i]
      //       _total += _item.amount * _item.price
      //     }
      //     this.form.total = _total.toFixed(2);
      //   },
      //   deep: true
      // }
    }
  }
</script>


// WEBPACK FOOTER //
// src/page/form/consumable/back.vue